var React = require('react');

function Venus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.548 3c-4.694 0-8.526 3.818-8.533 8.512-.006 4.343 3.277 7.912 7.486 8.436v3.306H11.63v2.051h2.87v3.076h2.051v-3.076h2.872v-2.051h-2.872v-3.302c4.23-.506 7.534-4.083 7.527-8.44C24.073 6.818 20.242 3 15.548 3zm0 2.051a6.46 6.46 0 016.48 6.464 6.465 6.465 0 01-6.463 6.488h-.036a6.465 6.465 0 01-6.463-6.488 6.46 6.46 0 016.482-6.464z"}));
}

Venus.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Venus;

Venus.default = Venus;
